import { FunctionComponent } from 'react';
import { PageCannotLoad } from './PageCannotLoad';
import { usePageCannotLoadState } from './usePageCannotLoadState';

type WiredPageCannotLoadErrorProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    context?: any;
};

const InternalWiredPageCannotLoad: FunctionComponent<WiredPageCannotLoadErrorProps> = ({ error, context }) => {
    usePageCannotLoadState({ error, context });

    return <PageCannotLoad />;
};

export const WiredPageCannotLoad: FunctionComponent<WiredPageCannotLoadErrorProps> = ({ error, context }) => (
    <InternalWiredPageCannotLoad error={error} context={context} />
);
